import { render, staticRenderFns } from "./AddExchangeModal.vue?vue&type=template&id=3ec5a7c4"
import script from "./AddExchangeModal.vue?vue&type=script&lang=js"
export * from "./AddExchangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports